export const en = {
  opportunityRequestModal: {
    //modal states
    event_type_title: 'Choose how you want to volunteer',
    event_type_subtitle:
      'Let Purposely help you find the perfect volunteer opportunity',
    target_audience_validation: 'Please select your group type.',
    event_location_title: 'Choose your Location',
    event_location_subtitle:
      'Tell us where you want this opportunity to take place',
    location_type_validation: 'Select your location type.',
    event_dates_title: 'Choose your dates and attendees',
    event_dates_subtitle:
      'Tell us when you want this opportunity to take place and who will be joining',
    dates_validation: 'Please select at least 1 date.',
    time_period_validation: 'Please select at least one time of day.',
    event_review_title: 'Review your opportunity request',
    event_review_subtitle: 'Is there anything else you would like us to know?',
    
    //root index
    error_user_message: 'Please fix the errors below and try again.',
    error_description:
      "This error occurs when the data provided by the user does not pass all of the validations. Most of the time this is a user error, but it's possible that a field is missing from the form, or that data is not being saved properly.",
    error_range: "Please select a range of attendees.",
    error_min_and_max: "Both min and max values are required.",
    error_more_than_one: "Must select more than 1 person minimum for a team event. If you prefer to volunteer alone, choose Solo at step 1.",
    error_min_less_than_max: "Min must be less than max.",
    error_min_equals_max: "Min and max cannot be the same.",
    error_min_max_range: "Please keep the difference between min and max attendees within 5 people.",
    error_location_blank: "Add a location or select 'Virtual'.",
    greeting: "Hey ",
    back: "Back",
    continue: "Continue",
    submit: "Submit",
    of: "of",
    to: " to ",

    //opportunity type step --------------------
    solo_description:
      'Volunteer independently for a cause you care about. May require a volunteer application to be completed prior to voluntering.',
    team_description:
      'Volunteer with your department or friends. This is ideal if you have a specific group or team in mind.',
    open_group_description:
      'Open to anyone at the company and is first come first serve. Perfect for office locations where all employees can get involved',
    label_solo: "Solo",
    label_team: "Team",
    label_open_group: "Open Group",

    //location step
    location_type_label: "Location Type",
    location_type_in_person: "In Person",
    location_type_virtual: "Virtual",
    location_label: "What is the preferred city?",
    location_type_virtual_placeholder: "Select 'In Person' above to add a location",
    location_type_in_person_placeholder: "Find your preferred city or town",
    location_details_label: "Location Details",
    co_requesters_label: 'Co-organizer',
    co_requesters_hint: "A colleague organizing this with you. They'll get the same updates you do.",
    co_requesters_add: 'Add a co-organizer',
    co_requesters_primary: 'Primary',
    co_requesters_you_primary: 'You · Primary',
    co_requesters_you: 'You',
    co_requesters_added: "We'll email {{name}} to let them know once you submit.",
    co_requesters_added_edit: "We'll email {{name}} to let them know once you save.",
    co_requesters_solo: 'Volunteering with someone?',
    co_requesters_switch_team: 'Switch to Team',
    co_requesters_tooltip: "Your co-organizer can view and edit the request's details and remove themselves. They get the same email updates you do. Only you can cancel the request or remove them.",
    location_details_in_person_placeholder: "eg. Downtown Vancouver",
    location_type_hint: "Looking for a Virtual Event? You can always create your own by picking one from our <0>Marketplace!</0>",


    //dates attendees step
    dates_label: "What are some dates that would work?",
    dates_hint: "You cannot select dates less than 4 weeks from now. Ensure you select dates where you are available.",
    time_period_label: "Which time(s) of the day are best?",
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    attendees_label: "How many people do you think will attend?",
    unit_label: "people",

    // review step
    opportunity_type: "Opportunity Type",
    volunteering: "volunteering",
    edit: "Edit",
    location: "Location",
    none: "None",
    dates: "Dates",
    time_of_day: "Time of Day",
    attendees: "Attendees",
    additional_details: "Additional Details",
    additional_details_placeholder: "e.g. “We’re open to any opportunity, but ideally one where we work with food security or indigenous communities",

    //sucess step
    thanks: "Thanks ",
    update_message: "Your opportunity request was ",
    submitted: "submitted",
    edited: "edited",
    edit_description: "You can edit your request by going to the ",
    my_opportunity_requests: "My Events page",
    edit_description_end: " at any time.",
    summary: "Summary",
    summary_start: "You'll volunteer",
    summary_team: " with a team of {{attendees}}",
    whats_next: "What's next?",
    local_nonprofits: "Our team will source an opportunity from local nonprofits",
    response_time: "We'll get back to you within 1-3 weeks with an opportunity, prioritizing those coming up soon",
    conclusion: "If it works for you, confirm, and we'll create an event page so you can sign up",
    edit_request: "Edit Request",
    looks_great: "Looks Great!",

    //cancel modal
    cancel_changes_title: "Discard Your Changes",
    cancel_request_title: "Cancel Opportunity Request",
    cancel_changes_message: "Are you sure you want to discard your changes? Your request will stay as it was.",
    cancel_request_message: "Are you sure you want to stop here? This request hasn't been submitted, and what you've entered will be lost.",
  },
}
